module.exports = __webpack_public_path__ + "img/maxpaint-the-blacksmith.1e2b43f2.jpg";